
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "xmlns": "http://www.w3.org/2000/svg",
    "xmlns:xlink": "http://www.w3.org/1999/xlink",
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24"
  },
  "children": [
    {
      "tag": "defs",
      "children": [
        {
          "tag": "clipPath",
          "attrsMap": {
            "id": "clip-path"
          },
          "children": [
            {
              "tag": "rect",
              "attrsMap": {
                "id": "矩形_11207",
                "data-name": "矩形 11207",
                "class": "cls-1",
                "width": "24",
                "height": "24",
                "transform": "translate(168 404)"
              }
            }
          ]
        }
      ]
    },
    {
      "tag": "g",
      "attrsMap": {
        "id": "蒙版组_247",
        "data-name": "蒙版组 247",
        "class": "cls-2",
        "transform": "translate(-168 -404)"
      },
      "children": [
        {
          "tag": "path",
          "attrsMap": {
            "id": "shafa",
            "class": "cls-3",
            "d": "M6.65,14.588v.471a.95.95,0,0,1-1.9,0v-.471H.95A.946.946,0,0,1,0,13.647V4.706a.946.946,0,0,1,.95-.941H3.325V.819A.891.891,0,0,1,4.275,0h10.45a.892.892,0,0,1,.95.819V3.765H18.05a.946.946,0,0,1,.95.941v8.941a.946.946,0,0,1-.95.941h-3.8v.471a.95.95,0,0,1-1.9,0v-.471ZM3.325,4.706H.95v8.941h17.1V5.176a.473.473,0,0,0-.475-.471h-1.9V8.471h.95a.471.471,0,1,1,0,.941H2.375a.471.471,0,1,1,0-.941h.95V4.706ZM9.025.941H4.75a.473.473,0,0,0-.475.471V8a.473.473,0,0,0,.475.471H9.025V.941Zm5.225,0H9.975V8.471H14.25A.473.473,0,0,0,14.725,8V1.412A.473.473,0,0,0,14.25.941Z",
            "transform": "translate(171 408)"
          }
        }
      ]
    }
  ]
})
    }
  